import React, { useEffect, useMemo, useState } from "react";
import { Link } from "react-router-dom";
import { AboutUsURL, BaseURL } from "../../APIs/APIUrls";

export default function About() {
  const [aboutData, setAboutData] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let mounted = true;

    async function fetchAboutUs() {
      try {
        const response = await fetch(AboutUsURL + "GetAboutUsById_web/1", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({}),
        });

        const text = await response.text();
        let data;
        try {
          data = JSON.parse(text);
        } catch (error) {
          data = text;
        }

        let aboutUs = null;
        if (data && typeof data === "object") {
          aboutUs = data.data || data.Result || data.response || data.List || data;
          if (Array.isArray(aboutUs)) {
            aboutUs = aboutUs[0] || null;
          }
        }
        if (mounted) {
          setAboutData(aboutUs && typeof aboutUs === "object" ? aboutUs : null);
        }
      } catch (error) {
        console.error(error);
        if (mounted) setAboutData(null);
      } finally {
        if (mounted) setLoading(false);
      }
    }

    fetchAboutUs();
    return () => {
      mounted = false;
    };
  }, []);

  const resolveImageSrc = (imagePath, fallback) => {
    if (!imagePath) return fallback;
    if (
      imagePath.startsWith("http://") ||
      imagePath.startsWith("https://") ||
      imagePath.startsWith("data:") ||
      imagePath.startsWith("/")
    ) {
      return imagePath;
    }
    return BaseURL + imagePath;
  };

  const title = aboutData?.Title || "Welcome to the Hom Lengo";
  const description = aboutData?.Description ||
    "Welcome to Home Lengo, where we turn houses into homes and dreams into reality. At Home, we understand that a home is more than just a physical space, it's a place where memories are created, families grow, and life unfolds.";
  const ownerName = aboutData?.OwnerName || "Leslie Alexander";
  const designation = aboutData?.Designation || "CEO & founder";
  const image1 = useMemo(
    () => resolveImageSrc(aboutData?.ImagePath1, "/images/banner/item1.jpg"),
    [aboutData]
  );
  const image2 = useMemo(
    () => resolveImageSrc(aboutData?.ImagePath2, "/images/banner/item2.jpg"),
    [aboutData]
  );

  
  return (
    <section className="flat-section">
      <div className="container flat-header-wrapper-about">
        <div className="row justify-content-center">
          <div className="col-lg-8 text-center">
            <h1 className="title">{title}</h1>
            {loading ? (
              <p className="text-variant-1 desc">Loading about content...</p>
            ) : (
              <p
                className="text-variant-1 desc"
                dangerouslySetInnerHTML={{ __html: description }}
              />
            )}
            <div className="signature-box">
              <div className="top">
                <h6>{ownerName}</h6>
                <p className="text-variant-2">{designation}</p>
              </div>
              {/* <img
                alt=""
                width="211"
                height="116"
                src="/images/banner/signature.png"
              /> */}
            </div>
            <Link
              to={`/contact-us`}
              className="tf-btn btn-view primary hover-btn-view"
            >
              Contact us
              <span className="icon icon-arrow-right2"></span>
            </Link>
            <div className="box-img item1 ani5">
              <img
                alt=""
                width="155"
                height="155"
                src={image1}
              />
            </div>
            <div className="box-img item2 ani4">
              <img
                alt=""
                width="181"
                height="181"
                src={image2}
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
